import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { UserPreferencesEffects, UserPreferencesFeature } from './stores/user-preferences';
import { AuthEffects } from '@app/modules/authentication/store/auth/auth.effects';
import { provideDatadogRUM } from './services/datadog-rum.service';

@NgModule({
  imports: [StoreModule.forFeature(UserPreferencesFeature), EffectsModule.forRoot([UserPreferencesEffects, AuthEffects])],
  providers: [provideHttpClient(withInterceptorsFromDi())]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error('CoreModule has already been loaded. You should only import CoreModule in the AppModule only.');
    }
  }

  static forRoot(): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [provideDatadogRUM]
    };
  }
}
